import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/prospects/$prospectId/recordings/$recordingId/"
)({
  component: RouteComponent
});

function RouteComponent() {
  const params = Route.useParams();
  return <Navigate to={`${Route.fullPath}summary`} params={params} replace />;
}
